import { Record } from 'immutable';
import { actionTypes } from './login.actions';
import * as authActions from '../auth/auth.actions'
import { resetPasswordActions, forgotPasswordActions } from '../acct';
import { tenantHelpers } from '../tenantInfo';
import { Err } from '../err';

export const LoginState = Record({
  err: null,
  accessRevokedErr: null,
  message: '',
  isFetching: false
});

export const loginReducer = (state = new LoginState(), action) => {
  switch (action.type) {
    case actionTypes.CREATE_NEW_SESSION_BEGIN:
      return state.set('err', null)
                  .set('isFetching', true);
    case actionTypes.CREATE_NEW_SESSION_SUCCESS:
      return state.set('err', null)
                  .set('isFetching', false);
    case actionTypes.CREATE_NEW_SESSION_FAILURE:
      return state.set('err', new Err(action.err))
                  .set('isFetching', false);
    case resetPasswordActions.actionTypes.REDEEM_TOKEN_SUCCESS:
      var type = action.data.tokenType;
      var message = "";
      switch(type)
      {
        case "set-password":
          message = 'You have successfully set your password. Log in below.';
          break;
        case "reset-password":
        default:
          message = 'You have successfully reset your password. Log in below.';
          break;
      }
      return state.set('err', null)
                  .set('message', message)
    case forgotPasswordActions.actionTypes.CREATE_PASSWORD_RESET_SUCCESS:
      return state.set('err', null)
                  .set('message', 'If the email address is associated with a valid account, you will receive an email soon with instructions to reset your password.');
    case authActions.actionTypes.LOGOUT_RESET:
      return state.set('err', null)
                  .set('message', null);
    case authActions.actionTypes.INVALIDATE_CURRENT_SESSION:
      return state.set('err', null)
                  .set('message', `Your session has ended.  Please log back into ${tenantHelpers.getProductName()}.`);
    case authActions.actionTypes.INVALIDATE_CURRENT_SESSION_UNOBTRUSIVE:
      return state.set('err', null)
                  .set('message', `Your session has ended.  Please log back into ${tenantHelpers.getProductName()}.`);
    case authActions.actionTypes.REVOKE_ACCESS:
      return state.set('accessRevokedErr', new Err(action.err));
    case authActions.actionTypes.DELETE_CURRENT_SESSION_SUCCESS:
      return state.set('err', null)
                  .set('accessRevokedErr', null)
                  .set('message', `You have successfully logged out of ${tenantHelpers.getProductName()}. You can log in again below.`);
    default:
      return state
  }
}



// WEBPACK FOOTER //
// src/login/login.reducer.js